import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App.js";
import { GuestPage } from "./guests/GuestPage.js";
import "./theme.css";
import "./mobile.css";

// The guest page (#126) is for somebody who is not signed in and never will
// be: a stranger's phone opening the link in a queue text. It takes the
// path before the app does, so the app never tries to read `/g/<token>` as
// an organisation and a venue.
const guestToken = /^\/g\/([A-Za-z0-9_-]+)\/?$/.exec(window.location.pathname)?.[1];

createRoot(document.getElementById("root")!).render(
  <StrictMode>{guestToken ? <GuestPage token={guestToken} /> : <App />}</StrictMode>,
);
